

const Config = {
    ServerUrl: "https://5763ejpyivvxs2qwewin7vsovm0baxtj.lambda-url.us-west-2.on.aws/"
  };
  
  export default Config;